import { useState, useEffect, memo } from "react";
import styled from "styled-components";
import ReadBox from "./ReadBox.js";
import Info from "./Info.js";
import {
  getCurrentMarkerObj,
  isValidMarkerId,
  isNotValidMarkerIdAndDifferent,
  encryptStory,
  addWatermarkText,
} from "./Utility.js";
import toast from "react-hot-toast";
import { t } from "@lingui/core/macro";
import copy from "copy-to-clipboard";

const LabelW3w = styled.p`
  font-size: 18px;
  font-weight:500;
  margin:0;
  color:red;
  letter-spacing:0.4em;
  strong {
  color: #f3efef;
  letter-spacing:normal;
  }
  a {
  cursor:pointer;
  }
  } 
`;
/**
 * A memo component that displays a story reading box
 *
 * @param {object} props
 * @returns {JSX.Element}
 */
const DrawerContentRead = memo((options) => {
  const [data, setData] = useState(false);

  /**
   * A function that manages the share of a story
   * @param {object} shareData - A story share data
   * @returns {void} Launch a copy task for desktop and share process for mobile
   */
  const handlerShareStory = async (shareData) => {
    try {
      if (!navigator.share && shareData.url) {
        copy(shareData.url);
        toast(t`Great, link copied successfully!`, {
          icon: "👋",
        });
        return;
      }
      await navigator.share(shareData);
    } catch (err) {
      console.log(`Error: ${err}`);
    }
  };

  /**
   * A function that get a story data
   * @param {string} id - A story id
   * @returns {void} Set a variable of state
   */
  const getData = (id) => {
    getCurrentMarkerObj(id)
      .then((data) => {
        console.log(data);
        if (data.success) {
          setData({
            id: data.data._id,
            photos: data.data.photos,
            description: data.data.descriptionGive,
            position: {
              lat: data.data.position.coordinates[1],
              lng: data.data.position.coordinates[0],
            },
            w3wData: {
              address: data.data.w3wData.address,
              idW: data.data.w3wData.idW,
            },
            fullAddress: data.data.fullAddress,
            city: data.data.city,
            province: data.data.province,
            country: data.data.country,
            name: data.data.name,
            website: data.data.website,
            category: data.data.category,
            businessHours: data.data.businessHours,
          });
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    // Remove marker from map on unmount
    return () => {
      if (isValidMarkerId(data.id)) {
        setData(false);
      }
    };
  }, []);

  //
  useEffect(() => {
    // Check if the clicked marker is a pre-existing and valid marker
    if (
      options &&
      options.markerInUse &&
      isValidMarkerId(options.markerInUse.id) &&
      isNotValidMarkerIdAndDifferent(data.id, options.markerInUse.id)
    ) {
      getData(options.markerInUse.id);
      console.log("----- " + options.markerInUse);
    }
    // eslint-disable-next-line
  }, [options]);

  return (
    <>
      <div className="uploadBoxList">
        {console.log("Drawercontent re-renderizzato")}
        {data && isValidMarkerId(data.id) && data.hasOwnProperty("photos") && (
          <>
            {" "} 
            <LabelW3w>
              <a
                onClick={() =>
                  handlerShareStory({
                    title: "Sa Guida",
                    text: t`Share this story!`,
                    url: `${window.location.origin}/story/${encryptStory(
                      data.id,
                      data.position.lat,
                      data.position.lng
                    )}`,
                  })
                }
                href="#"
              >
                <img alt="" style={{"verticalAlign": "middle"}} src="/share.svg" />
              </a>
              ///
              <strong>
                {data.hasOwnProperty("w3wData") ? data.w3wData.address : ""}
              </strong>{" "}
            </LabelW3w>
            <ReadBox
              images={data.photos.map((aPhoto, index) => {
                return {
                  photo: aPhoto,
                  data_url: addWatermarkText(
                    aPhoto.url,
                    data.hasOwnProperty("w3wData") ? data.w3wData.address : ""
                  ),
                  publicId: aPhoto.publicID,
                };
              })}
            >
              {" "}
            </ReadBox>
            <Info data={data} />
          </>
        )}
      </div>
    </>
  );
});
export default DrawerContentRead;
